import { AnnotationType } from 'types/building'

export interface ElbowPositionPayload {
  head_h: number
  head_v: number
  mid_h: number
  mid_v: number
  h: number
  v: number
  type: AnnotationType
  isDraft: boolean
}

export class AnnotationElbowHandler {
  private positions: number[] = []

  public get count(): number {
    return this.positions.length
  }

  public get currentPositions(): number[] {
    return [...this.positions]
  }

  private static ensureTempHotspots(krpano: any): void {
    if (!krpano || typeof krpano.call !== 'function') return
    try {
      if (!krpano.get('hotspot[temp_circle_style]')) {
        krpano.call(
          `addhotspot(temp_circle_style);
           set(hotspot[temp_circle_style].visible, false);
           set(hotspot[temp_circle_style].width, 20);
           set(hotspot[temp_circle_style].height, 20);
           set(hotspot[temp_circle_style].url, '/krpano/assets/gray_head.png');
           set(hotspot[temp_circle_style].zorder, 2);
           set(hotspot[temp_circle_style].keep, true);`
        )
      }
      if (!krpano.get('hotspot[temp_circle_middle_style]')) {
        krpano.call(
          `addhotspot(temp_circle_middle_style);
           set(hotspot[temp_circle_middle_style].visible, false);
           set(hotspot[temp_circle_middle_style].width, 10);
           set(hotspot[temp_circle_middle_style].height, 10);
           set(hotspot[temp_circle_middle_style].url, '/krpano/assets/gray_head.png');
           set(hotspot[temp_circle_middle_style].zorder, 2);
           set(hotspot[temp_circle_middle_style].keep, true);`
        )
      }
      if (!krpano.get('hotspot[temp_polyline_style]')) {
        krpano.call(
          `addhotspot(temp_polyline_style);
           set(hotspot[temp_polyline_style].visible, false);
           set(hotspot[temp_polyline_style].polyline, true);
           set(hotspot[temp_polyline_style].bgcolor, '0xD9D9D9');
           set(hotspot[temp_polyline_style].zorder, 1);
           set(hotspot[temp_polyline_style].keep, true);
           set(hotspot[temp_polyline_style].scale, 1);
           set(hotspot[temp_polyline_style].zoom, true);`
        )
      }
      if (!krpano.get('hotspot[temp_polyline_style2]')) {
        krpano.call(
          `addhotspot(temp_polyline_style2);
           set(hotspot[temp_polyline_style2].visible, false);
           set(hotspot[temp_polyline_style2].polyline, true);
           set(hotspot[temp_polyline_style2].bgcolor, '0xD9D9D9');
           set(hotspot[temp_polyline_style2].zorder, 1);
           set(hotspot[temp_polyline_style2].keep, true);
           set(hotspot[temp_polyline_style2].scale, 1);
           set(hotspot[temp_polyline_style2].zoom, true);`
        )
      }
    } catch {
      // Ignore if krpano is unmounting
    }
  }

  public addClickPosition(
    h: number,
    v: number,
    krpano: any,
    targetType: AnnotationType = AnnotationType.COMMENT
  ): ElbowPositionPayload | null {
    AnnotationElbowHandler.ensureTempHotspots(krpano)
    this.positions.push(h, v)

    if (this.positions.length === 2) {
      // Click 1: Head Point (Start point of branch)
      if (krpano && typeof krpano.call === 'function') {
        krpano.call(
          `set(hotspot[temp_circle_style].visible,true);
           set(hotspot[temp_circle_style].ath,${h});
           set(hotspot[temp_circle_style].atv,${v});
           set(hotspot[temp_polyline_style].visible,true);
           set(hotspot[temp_polyline_style].point[0].ath,${h});
           set(hotspot[temp_polyline_style].point[0].atv,${v});`
        )
      }
      return null
    }

    if (this.positions.length === 4) {
      // Click 2: Middle Elbow Point
      if (krpano && typeof krpano.call === 'function') {
        krpano.call(
          `set(hotspot[temp_polyline_style].point[1].ath,${h});
           set(hotspot[temp_polyline_style].point[1].atv,${v});
           set(hotspot[temp_circle_middle_style].visible,true);
           set(hotspot[temp_circle_middle_style].ath,${h});
           set(hotspot[temp_circle_middle_style].atv,${v});
           set(hotspot[temp_polyline_style2].visible,true);
           set(hotspot[temp_polyline_style2].point[0].ath,${h});
           set(hotspot[temp_polyline_style2].point[0].atv,${v});`
        )
      }
      return null
    }

    if (this.positions.length >= 6) {
      // Click 3: Target Pin Point -> Complete 3-point branch
      if (krpano && typeof krpano.call === 'function') {
        krpano.call(
          `set(hotspot[temp_polyline_style2].point[1].ath,${h});
           set(hotspot[temp_polyline_style2].point[1].atv,${v});
           hide_temp_hotspot();`
        )
      }

      const payload: ElbowPositionPayload = {
        head_h: this.positions[0],
        head_v: this.positions[1],
        mid_h: this.positions[2],
        mid_v: this.positions[3],
        h,
        v,
        type: targetType,
        isDraft: true
      }

      this.reset(krpano)
      return payload
    }

    return null
  }

  public reset(krpano?: any): void {
    this.positions = []
    if (krpano && typeof krpano.call === 'function') {
      krpano.call('hide_temp_hotspot();')
    }
  }
}
